export const OnlinePresenceOptions = [
  {
    id: 'facebook',
    name: 'Facebook',
    image: 'social-network/48x48/facebook.svg',
  },
  {
    id: 'instagram',
    name: 'Instagram',
    image: 'social-network/48x48/instagram.svg',
  },
  {
    id: 'youtube',
    name: 'Youtube',
    image: 'social-network/48x48/youtube.svg',
  },
  {
    id: 'tikTok',
    name: 'TikTok',
    image: 'social-network/48x48/tiktok.svg',
  },
  {
    id: 'snapchat',
    name: 'Snapchat',
    image: 'social-network/48x48/snapchat.svg',
  },
  {
    id: 'other',
    name: 'txt_my_site_other',
  },
];
